import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useToast } from '../ToastContext';
import TripDetailScreen from '../screens/TripDetailScreen';
import LoadingState from './ui/LoadingState';
import { B } from '../constants';

// Signed-in trip view: /trips/:id for the owner and accepted collaborators.
// Access (and the caller's role) is decided by GET /api/trips/:id.
export default function TripRoute() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const showToast = useToast();
  const tripId = parseInt(id, 10);

  if (loading) return <LoadingState variant="spinner" message="Loading trip..." />;
  if (!user) {
    return (
      <div style={{ maxWidth: 480, margin: '0 auto', padding: '70px 20px', textAlign: 'center', color: B.muted }}>
        <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, color: B.night }}>Sign in to open this trip</h3>
        <button onClick={() => navigate('/?screen=trips')} style={{ marginTop: 20, background: B.forest, color: 'white', border: 'none', padding: '12px 28px', borderRadius: 20, fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>
          Sign In
        </button>
      </div>
    );
  }
  if (Number.isNaN(tripId)) return <div style={{ padding: 40, textAlign: 'center' }}>Trip not found</div>;

  const goScreen = (s, data) => {
    if (s === 'blogEdit' && data && data.id) navigate(`/blog/edit/${data.id}`);
    else navigate(s === 'trips' ? '/?screen=trips' : '/');
  };

  return <TripDetailScreen key={tripId} trip={{ id: tripId }} goScreen={goScreen} showToast={showToast} user={user} />;
}
